module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAfUlEQVQ4T92S0QmAMAxEXzdxFDdRJ1En0VF0E0eRK1ZCKaSg/hgolDSv6V0TeBDBYSdAqxg/gBcjbAfWS680t0BnzgftrWbBMWmiZNhd9zrcAL15cuouGQfgdi79bcq5sGSreATmbFCqYF0gl7fMxGq4NJbfwNLnhXyI83ACxuIkENqCKzAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download.png
// module id = 0SEy
// module chunks = 2